module.exports = __webpack_public_path__ + "static/media/location.5d04d752.svg";